import React, { Component } from "react";
import Volunteer from "views/Pma/PmaEditor/FourthPageComponents/Volunteer";

import GummowListingPackages from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/GummowListingPackages";
import AnnetteQuadrants from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/AnnetteQuadrants";
import BackPageImageContainer from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/BackPageImageContainer";
import BrettNote from "@/views/Pma/PmaEditor/FourthPageComponents/CustomAgentPages/BrettNote";
import TopAgentInfoAndAddress from "views/Pma/PmaEditor/FourthPageComponents/TopAgentInfoAndAddress";

class QVFourFirstLeft extends Component {
  render() {
    const {
      printVersion,
      version,
      agentData,
      altAgentData,
      hoData,
      currentArea,
      coverPageDetails,
      quadrantModalOpen,
      volunteerDetails,
      isDemo,
      fromEditor,
    } = this.props;
    const { listgenUserID } = agentData;
    const { mlsAreaID } = currentArea;
    conosle.log("qv4 first left", this.props);
    let isGummow = listgenUserID === "x101566";
    let isAnnetteVait = listgenUserID === "101001";
    let isBrett = listgenUserID === "100227";
    return (
      <div className="qv4-first-left">
        <TopAgentInfoAndAddress
          currentArea={currentArea}
          printVersion={printVersion}
          agentData={agentData}
          isDemo={isDemo}
          hoData={hoData}
          version={version}
          coverPageDetails={coverPageDetails}
          quadrantModalOpen={quadrantModalOpen}
          mlsAreaID={mlsAreaID}
          fromEditor={fromEditor}
        />
        {isGummow ? (
          <>
            <GummowListingPackages />
          </>
        ) : isBrett ? (
          <BrettNote />
        ) : listgenUserID === "x106550" ||
          listgenUserID === "x102286" ||
          listgenUserID === "x105047" ||
          listgenUserID === "x106421" ? (
          <BackPageImageContainer agentData={agentData} />
        ) : isAnnetteVait ? (
          <AnnetteQuadrants />
        ) : (
          <Volunteer
            currentArea={currentArea}
            printVersion={printVersion}
            agentData={agentData}
            altAgentData={altAgentData}
            volunteerDetails={volunteerDetails}
          />
        )}

        {/*<QuadrantContainer
          currentArea={currentArea}
          quadrantDetails={quadrantDetails}
          mlsAreas={mlsAreas}
          printVersion={printVersion}
          testimonials={testimonials}
          hoData={hoData}
        />
   
        <QVFourTestimonial
          testimonials={testimonials}
          agentData={agentData}
          printVersion={printVersion}
          currentArea={currentArea}
          fromEditor={fromEditor}
        />*/}
        {/*<QVFourMissionStatement
          missionStatement={missionStatement}
          currentArea={currentArea}
          agentData={agentData}
          mlsAreas={currentArea.mlsAreas}
          printVersion={printVersion}
        />*/}
        {/*{ mlsAreaID === "SBA-20FInv" &&
          quadrantDetails &&
          quadrantDetails.length ? (
          <>
            <ColorBlockQuadrantContainer
              currentArea={currentArea}
              quadrantDetails={quadrantDetails}
              mlsAreas={mlsAreas}
              printVersion={printVersion}
              testimonials={testimonials}
            />{" "}
            <QVFourTestimonial testimonials={testimonials} />
          </>
        ) : (
          <TaxRate agentData={agentData} printVersion={printVersion} />

        {/*<TaxRate agentData={agentData} printVersion={printVersion} />*/}
        {/*<ExpertsTrends agentData={agentData} printVersion={printVersion} />*/}
      </div>
    );
  }
}

export default QVFourFirstLeft;
